// extracted by mini-css-extract-plugin
module.exports = {"backgroundColor":"Booking_backgroundColor__7vt1z","innerContainer":"Booking_innerContainer__1BIh9"};